import { types } from "../../types/types";
import { MENU_SOLICITUDES_CUD } from "../../components/Discapacidad/data/constants";

const initialState = {
  route: "",
  activeStep: 0,
  activeBreadcrumb: MENU_SOLICITUDES_CUD.DESELECCIONAR,
  afiliadoSeleccionado: null,
  certificados: [],
  documentacion: [],
  documentacionAfiliado: [],
  efectorSeleccionado: null,
  estadoSolicitudes: null, //ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA,
  formularioCud: null,
  solicitudes: [],
  solicitudesContadores: [],
  solicitudSeleccionada: null,
  solicitudesTomadas: [],
  solicitudesTomadasUsuario: [],
  subTiposSolicitudes: [],
  tiposDocumentacion: [],
  tiposDocumentacionAbm: [],
  tiposPrestaciones: [],
  tiposSolicitudes: [],
  tiposTransportes: [],
  trackingSolicitudIntegracion: [],
  loading: false,
  notas: [],
  consumosAfiliado: []
};

export const discapacidadReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.start:
      return {
        ...state,
        loading: true,
      };
    case types.setDiscapacidadStep:
      return {
        ...state,
        activeStep: action.payload,
      };
    case types.setDiscapacidadRoute:
      return {
        ...state,
        route: action.payload
      };
    case types.setBreadcrumbCud:
      return {
        ...state,
        activeBreadcrumb: action.payload
      };
    case types.certificadosClean:
      return {
        ...state,
        comprobantes: [],
        loading: false,
      };
    case types.certificadosSuccess:
      return {
        ...state,
        comprobantes: action.payload,
        loading: false,
      };
    case types.certificadosError:
      return {
        ...state,
        loading: false,
      };
    case types.certificadosPost:
      return {
        ...state,
        certificados: [
          action.payload,
          ...state.certificados
        ],
        loading: false,
      };
    case types.certificadosUpdated:
      return {
        ...state,
        certificados: state.certificados.map(
          (item) => item.idCertificado === action.payload.idCertificado
            ? {...item, ...action.payload}
            : item
        ),
        loading: false,
      };
    case types.certificadosDelete: 
      return {
        ...state,
        certificados: state.certificados.filter(item => item.idCertificado !== action.payload),
        loading: false,
      };
    //CLEAR
    case types.discapacidadClearReducer:
      return {
        ...initialState,
        activeStep: state.activeStep,
        activeBreadcrumb: state.activeBreadcrumb,
      };
    //TIPO DOCUMENTACION ABM
    case types.discapacidadGetTiposDocumentacionSuccess:
      return {
        ...state,
        tiposDocumentacion: action.payload,
      };
    case types.discapacidadGetTiposDocumentacionError:
      return {
        ...state,
        tiposDocumentacion: [],
      };
    case types.discapacidadPostTiposDocumentacion:
      return {
        ...state,
        tiposDocumentacion: [
          ...state.tiposDocumentacion,
          action.payload
        ],
      };
    case types.discapacidadPutTiposDocumentacion:
      return {
        ...state,
        tiposDocumentacion: state.tiposDocumentacion.map(item => (
          item.idTipoDoc === action.payload.idTipoDoc ? action.payload : item
        )),
      };
    case types.discapacidadDeleteTiposDocumentacion:
      return {
        ...state,
        tiposDocumentacion: state.tiposDocumentacion.filter(item => (
          item.idTipoDoc !== action.payload.idTipoDoc
        )),
      };
    //TIPO DOCUMENTACION SOLICITUD
    case types.discapacidadGetTiposDocumentacionSuccessAbm:
      return {
        ...state,
        tiposDocumentacionAbm: action.payload,
      };
    case types.discapacidadGetTiposDocumentacionErrorAbm:
      return {
        ...state,
        tiposDocumentacionAbm: [],
      };
    case types.discapacidadCleanTiposDocumentacionAbm:
      return {
        ...state,
        tiposDocumentacionAbm: [],
      };
    case types.discapacidadPostTiposDocumentacionAbm:
      return {
        ...state,
        tiposDocumentacionAbm: [
          ...state.tiposDocumentacionAbm,
          action.payload
        ],
      };
    case types.discapacidadPutTiposDocumentacionAbm:
      return {
        ...state,
        tiposDocumentacionAbm: state.tiposDocumentacionAbm.map(item => (
          (!!action.payload.idTipoDocSolicitud && item.idTipoDocSolicitud === action.payload.idTipoDocSolicitud) || 
          (!!action.payload.idTipoDocAfiliado && item.idTipoDocAfiliado === action.payload.idTipoDocAfiliado)
          ? action.payload : item
        )),
      };
    case types.discapacidadDeleteTiposDocumentacionAbm:
      return {
        ...state,
        tiposDocumentacionAbm: state.tiposDocumentacionAbm.filter(item => (
          (!!item.idTipoDocSolicitud && item.idTipoDocSolicitud !== action.payload) || 
          (!!item.idTipoDocAfiliado && item.idTipoDocAfiliado !== action.payload)
        )),
      };
    //DOCUMENTACION SOLICITUD
    case types.discapacidadGetDocumentacionSuccess:
      return {
        ...state,
        documentacion: action.payload,
      };
    case types.discapacidadGetDocumentacionError:
      return {
        ...state,
        documentacion: [],
      };
    //DOCUMENTACION AFILIADO
    case types.discapacidadGetDocumentacionAfiliadoSuccess:
      return {
        ...state,
        documentacionAfiliado: action.payload,
      };
    case types.discapacidadGetDocumentacionAfiliadoError:
      return {
        ...state,
        documentacionAfiliado: [],
      };
    //SOLICITUDES TOMADAS
    case types.discapacidadSolicitudesTomadasUsuarioSuccess:
      return {
        ...state,
        solicitudesTomadasUsuario: action.payload,
      };
    case types.discapacidadSolicitudesTomadasUsuarioLiberar:
      return {
        ...state,
        solicitudesTomadasUsuario: state.solicitudesTomadasUsuario.filter(
          (item) => item.id !== action.payload
        ),
      };
    case types.discapacidadSolicitudesDesmarcarLiberada:
      return {
        ...state,
        solicitudes: state.solicitudes.map((item) =>
          item.idSolicitud === action.payload.idSolicitud
            ? {
              ...item,
              solicitudesIntegracionTomadas: [],
            }
            : item
        ),
      };
    case types.discapacidadSolicitudesTomadasUsuarioAgregar:
      return {
        ...state,
        solicitudesTomadasUsuario: [
          ...state.solicitudesTomadasUsuario,
          action.payload,
        ],
      };
    case types.discapacidadSolicitudesTomadasUsuarioError:
      return {
        ...state,
        solicitudesTomadasUsuario: [],
      };
    case types.discapacidadSolicitudesTomadasSuccess:
      return {
        ...state,
        solicitudesTomadas: action.payload,
      };
    case types.discapacidadSolicitudesTomadasLiberar:
      return {
        ...state,
        solicitudesTomadas: state.solicitudesTomadas.filter(
          (item) => item.id !== action.payload
        ),
      };
    case types.discapacidadSolicitudesTomadasError:
      return {
        ...state,
        solicitudesTomadas: [],
      };
    case types.discapacidadSolicitudesTomadasLimpiar:
      return {
        ...state,
        solicitudesTomadas: [],
        solicitudesTomadasUsuario: [],
      };
    case types.discapacidadSolicitudesMarcarTomada:
      return {
        ...state,
        solicitudes: state.solicitudes.map((item) =>
          item.idSolicitud === action.payload.solicitud.idSolicitud
            ? {
                ...item,
                solicitudesIntegracionTomadas: [
                  {
                    id: action.payload.id,
                    usuarioTomada: { userName: action.payload.auth.userName },
                    idUsuarioTomada: action.payload.auth.idUsuario,
                  },
                ],
              }
            : item
        ),
      };
    //TRACKING SOLICITUD
    case types.discapacidadGetTrackingSolicitudIntegracionSuccess:
      return {
        ...state,
        trackingSolicitudIntegracion: action.payload,
      };
    case types.discapacidadGetTrackingSolicitudIntegracionError:
      return {
        ...state,
        trackingSolicitudIntegracion: [],
      };
    //ESTADO SOLICITUDES
    case types.discapacidadSetEstadoSolicitudes:
      return {
        ...state,
        estadoSolicitudes: action.payload,
      };
    //AFILIADO SELECCIONADO
    case types.discapacidadSetAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: action.payload,
      };
    case types.discapacidadCleanAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: null,
      };
    //EFECTOR SELECCIONADO
    case types.discapacidadSetEfectorSeleccionado:
      return {
        ...state,
        efectorSeleccionado: action.payload,
      };
    case types.discapacidadCleanEfectorSeleccionado:
      return {
        ...state,
        efectorSeleccionado: null,
      };
    //TIPOS PRESTACIONES
    case types.discapacidadGetTiposPrestacionesSuccess:
      return {
        ...state,
        tiposPrestaciones: action.payload,
      };
    case types.discapacidadGetTiposPrestacionesError:
      return {
        ...state,
        tiposPrestaciones: [],
      };
    //TIPOS SOLICITUDES
    case types.discapacidadGetTiposSolicitudesSuccess:
      return {
        ...state,
        tiposSolicitudes: action.payload,
      };
    case types.discapacidadGetTiposSolicitudesError:
      return {
        ...state,
        tiposSolicitudes: [],
      };
    //TIPOS TRANSPORTE
    case types.discapacidadGetTiposTransportesSuccess:
      return {
        ...state,
        tiposTransportes: action.payload,
      };
    case types.discapacidadGetTiposTransportesError:
      return {
        ...state,
        tiposTransportes: [],
      };
    //SUB-TIPOS SOLICITUDES
    case types.discapacidadGetSubTiposSolicitudesSuccess:
      return {
        ...state,
        subTiposSolicitudes: action.payload,
      };
    case types.discapacidadGetSubTiposSolicitudesError:
      return {
        ...state,
        subTiposSolicitudes: [],
      };
    //SOLICITUDES
    case types.discapacidadGetSolicitudesSuccess:
      return {
        ...state,
        solicitudes: action.payload,
      };
    case types.discapacidadCleanSolicitudes:
      return {
        ...state,
        solicitudes: [],
      };
    case types.discapacidadGetSolicitudesError:
      return {
        ...state,
        solicitudes: [],
      };
    case types.discapacidadGetContadoresSolicitudesSuccess:
      return {
        ...state,
        solicitudesContadores: action.payload,
      };
    case types.discapacidadGetContadoresSolicitudesError:
      return {
        ...state,
        solicitudesContadores: [],
      };  
    //SOLICITUD SELECCIONADA
    case types.discapacidadCleanSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: null,
      };
    case types.discapacidadSetSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: action.payload,
      };
    case types.discapacidadUpdateSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: action.payload,
      };
    case types.discapacidadUpdateTerapiaSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: {
          ...state.solicitudSeleccionada, 
          integracionTerapia: action.payload
        },
      };
    case types.discapacidadUpdateTransporteSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: {
          ...state.solicitudSeleccionada, 
          integracionTransporte: action.payload
        },
      };
    case types.discapacidadAddPractica:      
      const practicasAux = Array.isArray(state.solicitudSeleccionada.practicas)
        ? [...state.solicitudSeleccionada.practicas]
        : [];
      return {
        ...state,
        solicitudSeleccionada: {
          ...state.solicitudSeleccionada, 
          practicas: [...practicasAux, action.payload],
        },
      };
    case types.discapacidadSetPracticas:
      return {
        ...state,
        solicitudSeleccionada: {
          ...state.solicitudSeleccionada, 
          practicas: action.payload,
        },
      };
    //FORMULARIO CUD
    case types.discapacidadSetFormularioCudSuccess:
      return {
        ...state,
        formularioCud: action.payload,
      };
    //NOTAS 
    case types.discapacidadGetNotasSuccess:
      return {
        ...state,
        notas: action.payload,
      };
      case types.discapacidadGetNotasError:
        return {
          ...state,
          notas: null,
        };
        case types.discapacidadGetConsumosAfiliadosSuccess:
          return {
            ...state,
           consumosAfiliado: action.payload,
          };
    default:
      return state;
  }
};
  